import { render } from "./MyServiceOrdersCard.vue?vue&type=template&id=53c7ac40&scoped=true&ts=true"
import script from "./MyServiceOrdersCard.vue?vue&type=script&lang=ts"
export * from "./MyServiceOrdersCard.vue?vue&type=script&lang=ts"

import "./MyServiceOrdersCard.vue?vue&type=style&index=0&id=53c7ac40&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c7ac40"]])

export default __exports__